module.exports = __webpack_public_path__ + "static/media/but_close.6359daae.svg";